// The checkbox glyphs used everywhere in Platinum (registered as MuiCheckbox
// defaults in theme.tsx). MUI's own have 2px corners on a 24-unit box; these
// take 4px, so a tick box sits in the same family as the header pills, the
// composer card and the agent's message cards rather than reading as a form
// control from another product (Adam, 11 Sep).
import React from 'react'
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

const BOX = { x: 3, y: 3, width: 18, height: 18, rx: 4.5 } as const

export function RoundedCheckboxBlank(props: SvgIconProps) {
  return (
    <SvgIcon {...props} data-testid="RoundedCheckboxBlankIcon">
      <rect {...BOX} fill="none" stroke="currentColor" strokeWidth="2" />
    </SvgIcon>
  )
}

export function RoundedCheckboxChecked(props: SvgIconProps) {
  return (
    <SvgIcon {...props} data-testid="RoundedCheckboxCheckedIcon">
      <rect {...BOX} fill="currentColor" />
      <path d="M10 16.4 6.1 12.5l1.4-1.4 2.5 2.5 6.5-6.5 1.4 1.4z" fill="#fff" />
    </SvgIcon>
  )
}

export function RoundedCheckboxIndeterminate(props: SvgIconProps) {
  return (
    <SvgIcon {...props} data-testid="RoundedCheckboxIndeterminateIcon">
      <rect {...BOX} fill="currentColor" />
      <rect x="7" y="11" width="10" height="2" rx="1" fill="#fff" />
    </SvgIcon>
  )
}
